import React from "react"
import { Link } from "gatsby"
import { Flex, HStack, Icon } from '@chakra-ui/react'
import { SlArrowRight } from 'react-icons/sl'

type Props = {
  ButtonName: String 
  url: string
}

const secondaryButton: React.FC<Props> = ({ButtonName, url}) => {
  return (
    <HStack>
    <Flex
  as={Link}
  to={url}
  w={'16rem'}
  py={'1rem'}
  lineHeight='1.2'
  px={'2rem'}
  fontSize={'1rem'}
  fontWeight={'bold'}
  bg={'white'}
  color={'blue'}
  _hover={{ bg: 'gray.30' }}
  _active={{ bg: 'gray.30' }}
  justify={'center'}
  wordBreak={'auto-phrase'}
>
{ButtonName}

</Flex>
{/* <Icon 
as={SlArrowRight}
ml={'-2.5rem'}
color={'blue'}
fontWeight={'bold'}
/> */}
</HStack>
  );
}

export default secondaryButton